import React from 'react';
import {ConfirmationDialog} from 'components/dialogs/ConfirmationDialog';
import {useTranslation} from 'react-i18next';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';
type Props = {
   onOk: () => void;
   disabled?: boolean;
   content?: React.ReactNode;
};

const ConfirmationWrapper: ReactFChildrenProps<Props> = (props) => {
   const {t} = useTranslation();
   const {children, onOk, disabled, content = t('Confirm?')} = props;
   const [isOpened, open] = React.useState(false);

   return (
      <>
         <span onClick={() => !disabled && open(true)}>{children}</span>
         {isOpened ? (
            <ConfirmationDialog
               onOk={() => {
                  open(false);
                  onOk();
               }}
               onCancel={() => {
                  open(false);
               }}
               content={content}
               title={t('Confirmation')}
            />
         ) : null}
      </>
   );
};

export default ConfirmationWrapper;
